/**
 * Created by lu on 2018/4/8.
 */
var nb = require('../../nb');
var util = require('../../util');
var toast = require('../../toast');
var $ = nb.opts.$;
var config = require('../../config/' + process.env.APP_CONFIG + '.json');
var url = config.cgiUrl;
var b2bCgiUrl = config.b2bCgiUrl;
var uploadUrl = config.uploadUrl;

function createUIID() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}

var token;
var uiid = createUIID();


function callErrorCallback(inError, inScope, inResult) {
    var error = inResult.error;
    if (inError) {
        inError.call(inScope, inResult);
    } else {
        toast.setOpts({
            text: error.info || error.errorInfo,
            status: 'danger'
        });
    }
}

var ajax = function (inOpts) {

    // console.log('begin');
    nb.model.set('ajaxReady', '');


    var opts = inOpts || {};
    var scope = opts.scope;
    var data = opts.data || {};
    var formData = opts.formData;
    var success = opts.success;
    var error = opts.error;
    var always = opts.always;
    var parameters = {};
    var cmd = inOpts.cmd;
    var ajaxOpts = {
        url: opts.url || url,
        type: opts.type || 'post',
        cache: false,
        crossDomain: true
    };
    var openId = nb.model.get('openId');
    jQuery.support.cors = true;
    $.ajaxSetup({cache: false});
    $.each(data, function (inName, inValue) {
        parameters[inName] = inValue;
    });

    if (openId) {
        parameters.openId = openId;
    }
    if (formData) {
        formData.append('cmd', cmd);
        formData.append('parameters', JSON.stringify(parameters));
        ajaxOpts.data = formData;
        ajaxOpts.processData = false;  // 告诉jQuery不要去处理发送的数据  false
        ajaxOpts.contentType = false;   // 告诉jQuery不要去设置Content-Type请求头 false
    } else {
        ajaxOpts.dataType = 'json';
        ajaxOpts.data = JSON.stringify({
            cmd: cmd,
            parameters: parameters,
            clientIdentifierCode: uiid,
            token: token
        });
        ajaxOpts.contentType = "application/json";
    }

    $.ajax(ajaxOpts).done(function (inResult) {
        // console.log(ajaxOpts.data + ' - done');
        // nb.model.set('ajaxReady', 'data-ready');

        var statusCode = inResult.statusCode;
        switch (statusCode) {
            case 0:
                var response = inResult.response;
                if (success) {
                    success.call(scope, response);
                }
                break;
            case 401:
                //todo token无效
                util.clearCookie();
                toast.setOpts({
                    text: inResult.error.info,
                    status: 'danger'
                });
                setTimeout(function (args) {
                    window.location.href = 'login.html'
                }, 2000);
                break;
            case 412:
            case 403:
            case 410:
            case 500:
                callErrorCallback(error, scope, inResult);
                break;
            default:
        }

    }).always(function () {
        // debugger
        if (always) {
            // debugger
            always.call(scope);
            // debugger
        }
        // debugger

        // console.log(ajaxOpts.data + ' - always');
        nb.model.set('ajaxReady', 'data-ready');

    }).fail(function () {
        // console.log(ajaxOpts.data + ' - fail');
        // nb.model.set('ajaxReady', 'data-ready');

        //TODO ajax请求错误处理,例如网络不可访问
        toast.setOpts({
            text: '网络无法访问',
            status: 'danger'
        });


    });
};
module.exports = {
    ajax: ajax,
    b2bCgiUrl: b2bCgiUrl,
    uploadUrl: uploadUrl,
    getUiid: function () {
        return uiid;
    },
    setToken: function (inToken) {
        token = inToken;
    }
};


//////////////////
// WEBPACK FOOTER
// ../src/js/io/product/io.js
// module id = 1
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39